import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const SwitchOrganizationPage = lazy(() =>
  import('../../pages/settings/SwitchOrganizationPage').then((m) => ({
    default: m.SwitchOrganizationPage,
  })),
);

export const Route = createFileRoute('/settings/switch-organization')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <SwitchOrganizationPage />
    </Suspense>
  ),
});
